import { AlertBanner, Link } from '@apollo/orbit';
import React from 'react';
import type { StatusPageMaintenance } from 'typings/StatusPageScheduledMaintenance';

import { LocalTimestamp } from 'src/components/timestamp/Timestamp';
import { useLocalStorage } from 'src/hooks/useLocalStorage';

const getMaintenanceWindow = (maintenance: StatusPageMaintenance) =>
  maintenance.status === 'maintenance_in_progress'
    ? { start: maintenance.started_at, end: maintenance.scheduled_end_at }
    : { start: maintenance.starts_at, end: maintenance.ends_at };

export const ScheduledMaintenances = ({
  maintenances,
}: {
  maintenances: ReadonlyArray<StatusPageMaintenance>;
}) => {
  const [dismissedMaintenanceIds, setDismissedMaintenanceIds] = useLocalStorage(
    'dismissedMaintenanceIds',
  );

  const maintenancesToShow = maintenances.filter(
    (maintenance) => !dismissedMaintenanceIds.includes(maintenance.id),
  );

  if (maintenancesToShow.length === 0) {
    return null;
  }

  return (
    <AlertBanner
      status="info"
      isDismissible
      onDismiss={() => {
        setDismissedMaintenanceIds([
          ...maintenancesToShow.map(({ id }) => id),
          ...dismissedMaintenanceIds,
        ]);
      }}
    >
      {maintenancesToShow.map((maintenance) => {
        const maintenanceBodyText = maintenance.last_update_message;
        const shortenMaintenanceBody =
          maintenancesToShow.length > 1 ||
          (maintenanceBodyText && maintenanceBodyText.length > 180);
        const { start, end } = getMaintenanceWindow(maintenance);

        return (
          <React.Fragment key={maintenance.id}>
            <div>
              Scheduled maintenance between{' '}
              <LocalTimestamp
                value={new Date(start)}
                className="font-semibold"
              />{' '}
              and{' '}
              <LocalTimestamp value={new Date(end)} className="font-semibold" />
              .{' '}
              <Link isExternal to={maintenance.url}>
                Learn more
              </Link>
            </div>
            {!shortenMaintenanceBody && <p>{maintenanceBodyText}</p>}
          </React.Fragment>
        );
      })}
    </AlertBanner>
  );
};
